module.exports = __webpack_public_path__ + "media/images/icons/flags/BE-24d040aa5b2c0cc396005f9328b23440.svg";